import { useSetTaskCalendarOverride as _useSetTaskCalendarOverride } from '@griply/hooks';
import { useGoals } from 'features/goals';
import { useSetTaskCalendarOverrideMutation } from 'shared/hooks/queries/use-set-task-calendar-override-mutation';

import { useExternalCalendarConnections } from './use-external-calendar-connections';

export const useSetTaskCalendarOverride = () => {
  const { mutate } = useSetTaskCalendarOverrideMutation();
  const connections = useExternalCalendarConnections();
  const goals = useGoals();

  return _useSetTaskCalendarOverride({ connections, goals, mutate });
};
